import React from 'react'
import ReactDOM from 'react-dom'
import thunkMiddleware from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import Home from './pages/home'
import Services from './pages/services'
import Team from './pages/team'
import reducers from './reducers'

import createHistory from 'history/createBrowserHistory'
import { Route, Redirect} from 'react-router'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
// import { push } from 'react-router-redux'

// import 'bootstrap/dist/css/bootstrap.css'
import './css/base.scss'

const history = createHistory()

function configureStore(preloadedState) {
   return createStore(
      reducers,
      preloadedState,
      applyMiddleware(
         thunkMiddleware,
         routerMiddleware(history)
      )
   )
}


// Add the reducer to your store on the `routing` key
const store = configureStore()

// Create an enhanced history that syncs navigation events with the store
// const history = syncHistoryWithStore(browserHistory, store)


history.listen(location => {
     window.ga('send', location);
});


ReactDOM.render(
  <Provider store={store}>
    { /* Tell the Router to use our enhanced history */ }
    <ConnectedRouter history={history} >
      <div>
      <Route exact path="/" component={Home} />
      <Route path="/services" component={Services}/>
      <Route path="/team" component={Team}/>
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
//store.dispatch(push('/foo'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/